import message from '@utils/helper/message';

import { getCurrentLanguageWord } from '../utils/helper/getCurrentLanguageWord';

export function showMessage(messageObj: Record<string, string>, isSuccess: boolean) {
  if (isSuccess) {
    message.success(getCurrentLanguageWord(messageObj));
  } else {
    message.error(getCurrentLanguageWord(messageObj));
  }
}
